import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './FontFamily.css';
import { changeTextProperty } from '../../../redux/actions/entities/texts';

class FontFamily extends Component {
  constructor(props) {
    super(props);

    this.fonts = {
      0: {
        font: 'Montserrat',
        name: 'Anna',
      },
      1: {
        font: 'Oswald',
        name: 'Catherine',
      },
      2: {
        font: 'Merriweather',
        name: 'Daphne',
      },
      3: {
        font: 'Playfair_Display_SC',
        name: 'Julia',
      },
      4: {
        font: 'Playfair_Display',
        name: 'Maria',
      },
      5: {
        font: 'Dancing_Script',
        name: 'Thelma',
      },
      6: {
        font: 'Amatic_SC',
        name: 'Zoe',
      },
      7: {
        font: 'DJB_Baby_Bump',
        name: 'Baby',
      },
    };

    this.handleChange = this.handleChange.bind(this);
  }


  options = () => Object.values(this.fonts).map(element => <option selected={element.font === this.props.font ? 'true' : ''} key={`font-${element.font}`} value={element.font}>{element.name}</option>)

  handleChange(event) {
    const { textFieldId } = this.props;
    const { value } = event.target;
    this.props.dispatch(changeTextProperty(textFieldId, 'font', value));
  }

  render() {
    return (
      <select name="fontFamily" onChange={this.handleChange}>
        { this.options() }
      </select>
    );
  }
}

FontFamily.defaultProps = {
  textFieldId: 0,
  font: 'Lato',
  dispatch: () => {},
};

FontFamily.propTypes = {
  textFieldId: PropTypes.number,
  font: PropTypes.string,
  dispatch: PropTypes.func,
};

export default connect()(FontFamily);



// WEBPACK FOOTER //
// ./src/components/text-tools/font-family/FontFamily.jsx